/* eslint-disable no-extend-native */
// eslint-disable-next-line no-restricted-globals
String.prototype.replaceAccent = function replaceAccent(str: string): string {
  const output = str
    .replace(/ç/g, "c")
    .replace(/ı/g, "i")
    .replace(/ü/g, "u")
    .replace(/ğ/g, "g")
    .replace(/ö/g, "o")
    .replace(/ş/g, "s")
    .replace(/Ç/g, "C")
    .replace(/İ/g, "I")
    .replace(/Ü/g, "U")
    .replace(/Ğ/g, "G")
    .replace(/Ö/g, "O")
    .replace(/Ş/g, "S")
    .replace(/Ç/g, "C");

  return output;
};
